import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import foundations from 'theme/foundations';
//import { contentful } from "api/contentful/client";
//import { GetAssetByID } from "api/contentful/queries.gql";
import { getAsset } from "api/webservice/content";
import { Flex } from "@chakra-ui/react";

type Props = {
  //assetid: string;
  //url: string;
  fields: any;
};

const ImageFile: React.FC<Props> = ({
  //assetid
  fields
}: Props) => {
  //console.log(fields);
  const [assetUrl, setAssetUrl] = useState("");
  //useEffect(() => {
  //  //contentful.query({query: GetAssetByID, variables:{assetid: assetid}})
  //  getAsset(assetid)
  //    .then(result => {
  //      console.log(assetid);
  //      console.log(result);
  //    setAssetUrl(result?.fields?.assetCollection?.items[0].fields.url)
  //   });
  //}, []);
    return (
      <Flex
      as="div"
      alignItems="center"
      justifyContent="center"
      px={[4, 12]}
      py={[6, 6]}
      w="100%"
    >
        {/*
      <img src={assetUrl} />

*/}

      <img src={fields.file?.url} />
      </Flex>
    );
}

export default ImageFile;
